import HelpOutline from "@mui/icons-material/HelpOutline";
import { IconButton, Tooltip } from "@mui/material";
import { useCurrentUser } from "hooks/useCurrentUser";
import { MouseEvent, useState } from "react";

import { ExplainableWasteLine } from "./types";
import { WasteClassificationDialog } from "./WasteClassificationDialog";

/**
 * The staff-only "why was this classified this way" affordance. Staff-gated
 * rather than flag-gated: `isStaff` is false while emulating a customer, and
 * the waste-rule-compliance-engine-ui flag stays a server-side gate until the
 * explanation is ready for customer eyes.
 */
export function ExplainClassificationButton({
  line,
  subtitle,
}: {
  line: ExplainableWasteLine;
  subtitle?: string;
}) {
  const { isStaff } = useCurrentUser();
  const [open, setOpen] = useState(false);

  // Rows in the line grid navigate on click; explaining must not also open
  // the line.
  const handleOpen = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setOpen(true);
  };

  if (!isStaff) return null;

  return (
    <>
      <Tooltip title="Explain this classification">
        <IconButton
          size="small"
          color="staff"
          onClick={handleOpen}
          aria-label="Explain this classification"
        >
          <HelpOutline fontSize="small" />
        </IconButton>
      </Tooltip>
      {open && (
        <WasteClassificationDialog
          open
          line={line}
          onClose={() => setOpen(false)}
          subtitle={subtitle}
        />
      )}
    </>
  );
}
